import React, { Fragment, useEffect, useState } from "react";
import useStore from "../../../states/store";
import { INITIAL_GET_PARAMS } from "../../../enums/generalEnums";
import { getUserList } from "../../../config/apisauce";
import { Box, Typography } from "@mui/material";
import { CreatorCard } from "./CreatorCard";
import { ACTIVE } from "../../../enums/statusEnums";
import { GenericNoData } from "../../../components/generic/GenericNoData";
import { UsersFour } from "@phosphor-icons/react";
import { CREATOR_FEED_WIDTH } from "../../../enums/themeEnum";
import { useTheme } from "@emotion/react";

const CollabCreatorsPage = () => {
  const theme = useTheme();
  const [{ popularTag, searchValue, loaderState, userIds, creatorFilters }, { openLoader, closeLoader }] = useStore();
  const [creators, setCreators] = useState([]);
  const [pagination, setPagination] = useState({ pageSize: 20, page: 0 });

  const fetchUserList = async () => {
    openLoader();
    const response = await getUserList({
      ...INITIAL_GET_PARAMS,
      status: ACTIVE,
      filters: creatorFilters,
      per_page: pagination?.pageSize,
      page: pagination?.page + 1,
      search: searchValue,
      ...((userIds?.length > 0 && (Object.keys(creatorFilters).length === 0)) ? { user_id: userIds } : {}),
    });
    if (response.ok) {
      setCreators(response?.data);
    }
    closeLoader();
  };

  const handleScroll = () => {
    const bottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;
    if (bottom && !loaderState) {
      setPagination((prev) => ({
        ...prev,
        pageSize: prev.pageSize + 20
      }));
    }
  };

  useEffect(() => {
    if (creators?.per_page < creators?.total) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [loaderState, creators]);

  useEffect(() => {
    fetchUserList();
  }, [searchValue, pagination]);

  return (
    <Fragment>
      {
        creators?.data?.length > 0 ? <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box sx={{ width: CREATOR_FEED_WIDTH }}>
            <Box sx={{ width: '100%' }}>
              {
                creators?.data?.length > 0 && <Typography
                  variant="h2"
                  fontSize={'1.5em'}
                  fontWeight={700}
                  mb={1.5}
                  color="#161C24"
                  textTransform={'uppercase'}
                >
                  {
                    searchValue ? `Results for "${searchValue}"`
                      : <><span style={{ color: theme.palette.primary.main }}>{popularTag}</span> CREATORS</>
                  }
                </Typography>
              }
            </Box>
            <Box
              display="inline-flex"
              flexDirection="row"
              flexWrap="wrap"
              gap={{ xs: '6px', xsm: '14px' }}
              sx={{
                justifyContent: 'flex-start'
              }}
            >
              {
                creators?.data?.map((creator, index) => {
                  return (
                    <CreatorCard
                      key={`creator-key-${index}`} creator={creator}
                      width={{ xs: '188px', xsm: '250px' }}
                      height={{ xs: '250px', xsm: '350px' }}
                    />
                  );
                })
              }
            </Box>
          </Box>
        </Box> : <GenericNoData
          size="128px"
          icon={<UsersFour size={60} />}
          customLabel={
            <Fragment>
              <Typography variant={'h5'} fontWeight={700}>No creators found</Typography>
              <Typography color="grey.dark">Explore different tags to discover your options!</Typography>
            </Fragment>
          }
          height={'80vh'}
          labelVariant="h6"
          labelColor="text.main"
        />
      }
    </Fragment>
  );
};

export default CollabCreatorsPage;